import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      landingPageDescription: `Welcome to MyTXOne – the ultimate hub that revolutionizes the way you
      access, download, and manage files, documents, and licenses for your
      devices and services, consolidating everything you need all in one
      place, all at your fingertips.`,
      "All rights reserved.": "All rights reserved.",
      "Invalid parameters": "Invalid parameters",
      Unauthorized: "Unauthorized",
      "Session Expired": "Session Expired",
      "Component not found": "Component not found",
      "Component file not found": "Component file not found",
      "Permission denied": "Permission denied",
      "Trial license not accepted": "Trial license not accepted",
      "Moxa license not accepted": "Moxa license not accepted",
      "License has expired": "License has expired",
      "Unknown error": "Unknown error",
      "License key cannot be empty": "License key cannot be empty",
      "Your license was registered successfully.":
        "Your license was registered successfully.",
      "License not start yet": "License not start yet",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
